// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__4Y1V9","colCheckbox":"styles_colCheckbox__tAnrM"};